import React from "react";

import config from "./../../utils/const";
import "./style.scss";

import Buttom from "../../components/Buttom";
import Title from "../../components/Title";
import LayoutDefault from "../Shared/LayoutDefault";

import { ContextDefault } from "./../../context/Provider";

const EsportePerfil = () => {
  const context = React.useContext(ContextDefault);

  React.useEffect(() => {
    context.actions.setProgressBarVisiblity(false);
  }, [context.actions]);

  return (
    <LayoutDefault
      className="wrapper-perfil"
      renderButtom={() => (
        <div className="wrapper-buttons">
          <Buttom to={`${config.url}esporte/pessoa-fisica`} text="Pessoa Física" />
          <Buttom to={`${config.url}esporte/pessoa-juridica`} text="Pessoa Jurídica" />
        </div>
      )}
    >
      <img src={`${config.pathImages}logo-nar-sp.png`} alt="NAR" />
      <p>
        <b>O Núcleo de Alto Rendimento Esportivo de São Paulo</b> é um centro de excelência esportiva referência internacional na pesquisa, avaliação e prescrição do treinamento esportivo.
      </p>
      <p>
        O Instituto Península acredita que o NAR contribui não só para o legado que o esporte pode trazer para o país, mas principalmente para o desenvolvimento do atleta como indivíduo.&nbsp;
        <a href="http://www.narsp.com.br/" target="_blank" rel="noopener noreferrer">
          Saiba mais
        </a>
      </p>
      <Title className="title">Selecione seu perfil de apoiador:</Title>
    </LayoutDefault>
  );
};

export default EsportePerfil;
